export function getEnvironment() {
  // check if we're in development mode (local dev server)
  if (import.meta.env.DEV) {
    return 'development';
  }

  return import.meta.env.MODE || 'unknown';
}
